import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import './Popup.css';

const Popup = ({ isOpen, onClose, title, message, icon }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="popup-content card"
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            transition={{ type: 'spring', bounce: 0.4 }}
          >
            <div className="popup-icon">
              {icon || <CheckCircle2 size={48} color="var(--durian-green)" />}
            </div>
            <h3 className="popup-title">{title}</h3>
            <p className="popup-message">{message}</p>
            <button className="btn-primary popup-btn" onClick={onClose}>
              Got it!
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Popup;
